import React from 'react'

export default function ShowTheExcel( { handleChange , handleField , handleUpload } ) {

  function handleTheChange( e )
  {
    //handleChange( value ) ;

    console.log( e.target.value )

    handleChange( e.target.value)
  }

  return (
    <div className='excel'>

        <label htmlFor='pestana'>Pestaña &nbsp;</label>
        
        <input className="anim01" type='text' name='pestana' onChange={handleTheChange}>
        
        </input>

        &nbsp;
        <label htmlFor='campo'>Campo &nbsp;</label>
        <input className="anim01" type='text' name='campo' onChange={handleField}>
        
        </input>


        <input type='file' accept='.xlsx,.xls' onChange={handleUpload}>
        </input>


    </div>
  )
}
